import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { acceptHeadNurseInviteRequest, clearHeadNurseMessage } from "../redux/actions/headNurse";
import { signupNurseRequest } from "../redux/actions/nurses";
import { AppState } from "../redux/types";
import { ROLE } from "../utils/constants";
import FormContainer from "./FormContainer";
import Message from "./Message";
import SignupForm from "./SignupForm";
import SuccessModal from "./successModal/SuccessModal";
import { localePath } from "../i18n/config";

const RegisterNurseForm = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const history = useHistory();
    const [getPath, setPath] = useState("");
    const [token, setToken] = useState("");
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const nurses: any = useSelector((state: AppState) => state.nurses);
    const headNurse: any = useSelector((state: AppState) => state.headNurse);

    function useQuery() {
        const { search } = useLocation();
        return useMemo(() => new URLSearchParams(search), [search]);
    }
    let query = useQuery();

    useEffect(() => {
        let token = query.get("token");

        if (token) {
            const pathname = location.pathname.split("/");
            setPath(pathname[3]);
            setToken(token);
        } else {
            history.push(localePath("kirjaudu"));
        }
    }, [query, location, history]);

    const handleCreateAccount = (data: any) => {
        const _data = {
            ...data,
            role: query.get("is-head-nurse") === "true" ? "head_nurse" : getPath,
            token: token,
        };
        if (getPath === ROLE.HEAD_NURSE) {
            dispatch(acceptHeadNurseInviteRequest({ ...data, token }));
        } else {
            dispatch(signupNurseRequest(_data));
        }
    };

    useEffect(() => {
        if (headNurse.message?.status === 200 && headNurse.message?.message && !headNurse.loading) {
            setShowSuccessModal(true);
        }
    }, [headNurse.message, headNurse.loading]);

    useEffect(() => {
        if (nurses.message?.status === 200 && nurses.message?.message && !nurses.loading) {
            setShowSuccessModal(true);
        }
    }, [nurses.message, nurses.loading]);

    const getSuccessMessage = () => {
        return getPath === ROLE.HEAD_NURSE ? "Osastonhoitajan tili on luotu onnistuneesti!" : "Sairaanhoitajan tili on luotu onnistuneesti!";
    };

    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
        dispatch(clearHeadNurseMessage());
    };
    return (
        <div>
            <div className="alert-message">
                {Object.keys(nurses.message).length !== 0 && (
                    <Message variant={nurses.message?.status === 200 ? "info" : "danger"}>
                        <div className="message-text">{nurses.message?.message}</div>
                    </Message>
                )}
            </div>
            <h1 className="user-form-header">Sairaanhoitaja</h1> {/* Nurse */}
            <FormContainer>
                <h3 className="user-form-header">Luo tili</h3> {/* Create an account */}
                <SignupForm onCreateAccount={handleCreateAccount} />
            </FormContainer>
        {<SuccessModal
            show={showSuccessModal}
            onHide={handleCloseSuccessModal}
            title="Tili luotu onnistuneesti!"
            message={getSuccessMessage()}
            subMessage="Sinut ohjataan kirjautumissivulle automaattisesti..."
            redirectPath="/kirjaudu"
            redirectButtonText="Siirry kirjautumaan"
            autoRedirect={true}
            redirectDelay={3000}
        />}
        </div>
    );
};
export default RegisterNurseForm;
